import type { DecoratedOrderProduct, OrderStatusId } from '@witmetrics/utils';
import {
  ORDER_PRODUCT_STATUS_ID,
  ORDER_STATUS_ID,
} from '@witmetrics/utils/constants';
import { asyncMap } from '@witmetrics/utils/arrays';
import { API } from '@/api';

const { FULFILLED } = ORDER_STATUS_ID;
const { COMPLETE } = ORDER_PRODUCT_STATUS_ID;

export const classes = {
  button:
    'mt-2 mb-3 text-grey-8 dark:text-mauve-1 text-base place-start py-2 pl-2 pr-4 bg-transparent rounded-lg outline-none cursor-default',
  clickable:
    'cursor-pointer hover:bg-grey-3 dark:hover:bg-white/[0.1] transition-colors',
  orderStatusCircle: 'mr-2 text-taupe-2 dark:text-mauve-2',
  label: 'text-base font-medium',
};

export function updateOrderStatus(
  orderId: number,
  orderStatusId: OrderStatusId
) {
  return API.Orders.updateOrder(orderId, { orderStatusId });
}

export function updateProductsStatus(orderProducts: DecoratedOrderProduct[]) {
  return asyncMap(orderProducts, (op) =>
    API.Orders.updateOrderProduct(op.id, { orderProductStatusId: COMPLETE })
  );
}

export function hasOpenProducts(
  orderStatusId: OrderStatusId,
  orderProducts: DecoratedOrderProduct[]
) {
  return (
    orderStatusId === FULFILLED &&
    orderProducts.some((op) => op.orderProductStatusId !== COMPLETE)
  );
}
